import {Injectable} from '@angular/core';
import {Order} from '../models/order';
import {OrderForm} from '../models/order-form';
import {Wifi, WifiForm} from '../../shared/models/wifi';
import {NetworkSettings} from '../../shared/models/network-settings';
import {DateFormatService} from '../../shared/services/date-format.service';
import {Address} from '../../shared/models/address';
import {Culture} from '../../shared';
@Injectable({
  providedIn: 'root'
})
export class OrderMapperService {

  constructor(private dateFormatService: DateFormatService) {}

  formToDb(data: OrderForm): Order {
    return {
      'client': {
        'uuid': data.client ? data.client.uuid : null,
      },
      'site': {
        'externalID': data.site.externalID,
        'timeZone': data.site.ianaCode,
        'name': data.site.name,
        'id': data.site.id,
        'uuid': data.site.uuid,
        'addresses': null,
        'displayName': data.site.name
      },
      'productionLine': { code:  data.productionLine.productionLine.code },
      'shipment': data.misc.shipmentForm.shipment,
      'subscription': {
        'cultures':    data.subscription.general.cultures.code,
        'isSold':    data.subscription.base.productForm.isSold,
        'statutoryName': data.subscription.general.statutoryName ? data.subscription.general.statutoryName : null,
        'type': null,
        'program': null,
        'licence': null,
        'product': {
          'name': null,
          'id': data.subscription.base.productForm.product.id
        },
        'service': {
          'name': null,
          'id': data.subscription.base.productForm.service.id
        },
        'status': data.subscription.base.productForm.status.id,
        'network': this.networkToDB(data.subscription.network),
        'name': data.subscription.base.prefix ? data.subscription.base.prefix + ' ' +
          (data.subscription.general.name !== null ? data.subscription.general.name : '' ) :
          (data.subscription.general.name !== null ? data.subscription.general.name : '' ),
        'comments': data.misc.commentsForm.comments,
        'cmsServerID':  data.subscription.base.serverForm.cms.id ? data.subscription.base.serverForm.cms.id : null,
        'server': {
          id: data.subscription.base.serverForm.url.id ,
          ip: data.subscription.base.serverForm.ip,
          name: data.subscription.base.serverForm.name,
          url: data.subscription.base.serverForm.url.id,
        },
        'id': data.subscription.id,
        'screenRotation': data.subscription.base.productForm.screenRotation.id,
        'players': data.subscription.player,
        'closed': null,
        'isOrderOpened': null,
        'externalID': null,
        'timeZone': null,
        'deleted': null
      },
      'addresses': data.addresses[1]['checkBox'] === false ? data.addresses : [data.addresses[0]],
      'contact': {
        'surname': data.contact.surname,
        'email': data.contact.email,
        'phone': data.contact.phone,
        'name': data.contact.name,
        'id': data.contact.id,
        'uuid': data.contact.uuid,
        'department': data.contact.department,
        'mobile': data.contact.mobile
      },
      'expeditionDate': data.misc.expeditionForm.expeditionDate,
      'shippingInfo': null,
      'status': null,
      'uuid': data.uuid,
      'type': data.type,
      'created': data.created,
      'updated': data.updated,
      'id': data.id,
      'displayName': data.displayName,
      'player': {
        'displayName': data.misc.playerInfo ? data.misc.playerInfo.displayName : null,
        'deviceMacAddress': data.misc.playerInfo ? data.misc.playerInfo.deviceMacAddress : null,
        'deviceID': data.misc.playerInfo ? data.misc.playerInfo.deviceID : null,
        'isDefault': data.misc.playerInfo ? data.misc.playerInfo.isDefault : null,
        'deviceModel': data.misc.playerInfo ? data.misc.playerInfo.deviceModel : null,
        'deviceFirmware': null,
        'lastConnection': null,
        'deviceImage': null,
        'productID': null,
        'id': null,
        'name': null
      },
      'hasMaterial': data.misc.expeditionForm.hasMaterial,
      'hasSetup': data.misc.expeditionForm.hasSetup,
      'disableAutoPublish': true,
      'concepts': data.concepts.concepts.id ,
    };
  }

  dbToForm(data: Order): OrderForm {
    return {
      'addresses': data.addresses,
      'client': {
        'uuid': data.client.uuid
      },
      'misc': {
        'commentsForm': {
          'commentsBlog': data.subscription.comments,
          'comments': data.subscription.comments,
        },
        'expeditionForm': {
          'expeditionDate': data.expeditionDate,
          'hasMaterial': data.hasMaterial,
          'hasSetup': data.hasSetup,
          'orderCountThisDay': data.orderCountThisDay,
        },
        'shipmentForm': {
          'shipment': data.shipment,
        },
        'byForm': {
          'createdBy': data.createdBy + '   ' + this.dateFormatService.stringToFullDateTime(data.created),
          'updatedBy': data.updatedBy + '   ' +  this.dateFormatService.stringToFullDateTime(data.updated),
        },
        'playerInfo': {
          'displayName': data.player ? data.player.displayName : null,
          'deviceMacAddress': data.player ? data.player.deviceMacAddress : null,
          'deviceID': data.player ? data.player.deviceID : null,
          'isDefault': data.player ? data.player.isDefault : null,
          'deviceModel': data.player ? data.player.deviceModel : null
        }
      },
      'contact': {
        'name': data.contact ? data.contact.name : '',
        'surname': data.contact ? data.contact.surname : '',
        'phone': data.contact ? data.contact.phone : '',
        'email': data.contact ? data.contact.email : '',
        'id': data.contact ? data.contact.id : null,
        'uuid': data.contact ? data.contact.uuid : '',
        'mobile': data.contact ? data.contact.mobile : '',
        'department': data.contact ? data.contact.department : '',
      },
      'site': {
        'ianaCode': data.site.ianaCode,
        'timezoneName': data.site.ianaCode,
        'externalID': data.site.externalID,
        'name': data.site.name,
        'id': data.site.id,
        'uuid': data.site.uuid
      },
      'productionLine': {
        'productionLine': {
          'code': data.productionLine?.code,
        },
      },
      'subscription': {
        'base': {
          'name': data.subscription.name,
          'productForm': {
            'product': {
              'id': data.subscription.product.id,
              'name': data.subscription.product.name,
              'audio': false,
              'video': false
            },
            'service': {
              'name': data.subscription.service.name,
              'id': data.subscription.service.id
            },
            'status': {
              'id': data.subscription.status,
              'name': '',
              'audio': false,
              'video': false
            },
            'screenRotation': {
              'id': data.subscription.screenRotation
            },
            'isSold': data.subscription.isSold,
          },
          'serverForm': {
            'server': {
              'id': data.subscription.server ? data.subscription.server.id : null,
            },
            'cms': {
              'id': data.subscription.cmsServerID ? data.subscription.cmsServerID : null,
            }
            ,
            'ip': data.subscription.server ? data.subscription.server.ip : null,
            'name': data.subscription.server ? data.subscription.server.name : null,
            'url': {
              'id': data.subscription.server ? data.subscription.server.id : null
            },
          },
        },
        'general': {
          'cultures': data.subscription.cultures,
          'name': data.subscription.name,
          'statutoryName': data.subscription.statutoryName,

        },
        'network': this.networkDbToForm(data.subscription.network),
        'id': data.subscription.id,
        'uuid': data.subscription.uuid,
        'player': data.subscription.players
      },
      'uuid': data.uuid,
      'type': data.type,
      'created': data.created,
      'updated': data.updated,
      'id': data.id,
      'displayName': data.displayName
    }
  }

  networkToDB(data: NetworkSettings): NetworkSettings {
    return {
      'status': true,
      'ipAddress': {
        'isDhcp': data.ipAddress.isDhcp ? data.ipAddress.isDhcp : false,
        'ip': !data.ipAddress.isDhcp ? data.ipAddress.ip : null,
        'mask': !data.ipAddress.isDhcp ? data.ipAddress.mask : null,
        'gateway': !data.ipAddress.isDhcp ? data.ipAddress.gateway : null,
        'dns1': !data.ipAddress.isDhcp ? data.ipAddress.dns1 : null,
        'dns2': !data.ipAddress.isDhcp ? data.ipAddress.dns2 : null
      },
      'proxy': {
        'enable': data.proxy.addressProxy && data.proxy.port ? true : false,
        'address': data.proxy.addressProxy,
        'port': data.proxy.port
      },
      'wifi': this.wifiToDB(data.wifi)
    }
  }

  wifiToDB(data: WifiForm): Wifi {
    return {
      'ssid': data.ssid,
      'security': {
        'password': data.security_password,
        'type': data.security_type.code,
      },
      'eap': {
        'anonymous_identity': data.eap_anonymous_identity,
        'ca_certificate': data.eap_ca_certificate,
        'identity': data.eap_identity,
        'methodName': data.eap_methodName.code,
        'password': data.eap_password,
        'phase_2_authentication': data.eap_phase_2_authentication.code,
        'user_certificate': data.eap_user_certificate,
      },
      'enable': !!data.ssid,
    }
  }

  wifiDBToForm(data: Wifi): WifiForm {
    if (data) {
      return {
        'eap_anonymous_identity': data.eap ? data.eap.anonymous_identity : null,
        'eap_ca_certificate': data.eap ? data.eap.ca_certificate : null,
        'eap_identity': data.eap ? data.eap.identity : null,
        'eap_methodName': {
          'code': data.eap ? data.eap.methodName : null
        },
        'eap_password': data.eap ? data.eap.password : null,
        'eap_phase_2_authentication': { 'code': data.eap ? data.eap.phase_2_authentication : null },
        'eap_user_certificate': data.eap ? data.eap.user_certificate : null,
        'enable': !!data.ssid,
        'id': data.id,
        'uuid': data.uuid,
        'security_password': data.security ? data.security.password : null,
        'security_type': { code: data.security ? data.security.type : null },
        'ssid': data.ssid,
      }
    } else {
      return {
        'eap_anonymous_identity': null,
        'eap_ca_certificate': null,
        'eap_identity': null,
        'eap_methodName': {
          'code': null
        },
        'eap_password': null,
        'eap_phase_2_authentication': { 'code': null },
        'eap_user_certificate': null,
        'enable': null,
        'id': null,
        'uuid': null,
        'security_password': null,
        'security_type': { code: null },
        'ssid': null,
      }
    }
  }

  networkDbToForm(data: NetworkSettings): NetworkSettings {
    return {
      'status': data.status,
      'ipAddress': {
        'dns1': data.ipAddress && data.ipAddress.dns1 ? data.ipAddress.dns1.trim() : null,
        'dns2': data.ipAddress && data.ipAddress.dns2 ? data.ipAddress.dns2.trim() : null,
        'gateway':
          data.ipAddress && data.ipAddress.gateway ? data.ipAddress.gateway.trim() : null,
        'id': data.ipAddress && data.ipAddress.id,
        'ip': data.ipAddress && data.ipAddress.ip ? data.ipAddress.ip.trim() : null,
        'isDhcp': data.ipAddress && data.ipAddress.isDhcp,
        'mask': data.ipAddress && data.ipAddress.mask ? data.ipAddress.mask.trim() : null,
        'uuid': data.ipAddress && data.ipAddress.uuid,
      },
      'wifi': this.wifiDBToForm(data.wifi),
      'proxy': {
        'addressProxy': data.proxy ? data.proxy.address : null,
        'enable': data.proxy ? data.proxy.enable : null,
        'login': data.proxy ? data.proxy.login : null,
        'password': data.proxy ? data.proxy.password : null,
        'port': data.proxy ? data.proxy.port : null
      }
    }
  }

  // tslint:disable-next-line:no-any
  // getAddress(address: Address[]): any {
  //  const addressByType = [];
  //  if (address && address[0].addressType.toLowerCase() === 'site') {
  //    addressByType[0] = address[0];
  //    if (address.length === 2) {
  //      addressByType[1] = address[1];
  //    }
  //  } else {
  //    addressByType[0] = address[1];
  //    addressByType[1] = address[0] ;
  //  }
  //  return addressByType;
  // }
}
